import {ReactElement, RefObject, useState, useEffect, useLayoutEffect} from "react"
import "./FullScreenButton.scss"

function toggleClassNameForSiblingsRecursively(
el: HTMLElement, className: string, toggleOn: boolean): void {
  if (el.tagName === "BODY") {
    return
  }
  const parent = el.parentElement!
  Array.from(parent.children).forEach(sibling => {
    if (sibling === el) {
      return;
    }
    if (toggleOn) {
      sibling.classList.add(className)
    } else {
      sibling.classList.remove(className)
    }
  })
  toggleClassNameForSiblingsRecursively(parent as HTMLElement, className, toggleOn)
}

type Props = {
  elementToFullScreen: RefObject<HTMLElement | null>
}

export function FullScreenButton({elementToFullScreen}: Props): ReactElement {
  const [fullScreen, setFullScreen] = useState(false)

  useEffect(() => {
    if (!fullScreen) {
      return;
    }
    const listener = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setFullScreen(false);
      }
    }
    document.addEventListener("keyup", listener);
    return () => document.removeEventListener("keyup", listener);
  }, [fullScreen]);

  useLayoutEffect(() => {
    const run = () => {
      if (!elementToFullScreen.current) {
        return
      }
      toggleClassNameForSiblingsRecursively(
        elementToFullScreen.current, "hide-because-of-fullscreen", fullScreen)
    }

    const observer  = new MutationObserver(run)
    run()
    const config = { attributes: false, childList: true, subtree: true,
      characterData: false};
    observer.observe(document.querySelector("body")!, config)
    return () => observer.disconnect()
  }, [fullScreen, elementToFullScreen])

  return <button onClick={() => setFullScreen(fs => !fs)} className={
    fullScreen ? "fullscreen-button on" : "fullscreen-button off"} >
  </button>
}
